<div data-test-id="erledigung">{{body.erledigung | enumToLabel: erledigungLabel}}</div>
